// extracted by mini-css-extract-plugin
export default {"card":"styles_card__dTJBi","wrapper":"styles_wrapper__sXkIE","right":"styles_right__t1ixw","box":"styles_box__Ttpwu","icons":"styles_icons__md6FM"};